// フォトいいね用の支払いフォーム

<template lang="pug">
.iine-payment-form
  ps-form-item(label='お支払い方法', required)
    ul

      //- カード決済およびPayPay決済
      li
        ps-radio(
          v-if='cardAvailable',
          radio-value='2',
          v-model='payment.id',
          full-width,
          @input='update'
        ) クレジットカード (手数料不要)
          .description(slot='description')
            payjp-card-and-paypay-form(
              :sale-id="saleId",
              :client-secret="payjpClientSecret",
              @changeCardFormIsOK='updateCardFormStatus',
              ref='payjpCardAndPaypayFormComponent'
            )

      //- コンビニ決済
      li(style='margin-top: 0.5rem')
        ps-radio(
          v-if='conveniAvailable',
          radio-value='3',
          v-model='payment.id',
          full-width,
          @input='update',
        ) コンビニ決済 (手数料不要)
          .description(slot='description')
            p.caption お支払いするコンビニを選択してください。

            .conveni-group(:class='{ error: getError("conveni.cvs") }')

              ps-radio(
                v-for='item in convenis', :key='item.code',
                v-model='payment.conveniCvs', :radio-value='item.code',
                color='blue', full-width,
                @input='update'
              )
                span.conveni-icon(:class='item.code')
                | {{ item.name }}
</template>

<script>
import PayjpCardAndPaypayForm from './components/payjp-card-and-paypay-form'
import convenis from '@/helpers/convenis'

export default {
  name: 'IinePaymentForm',

  components: {
    PayjpCardAndPaypayForm,
  },

  props: {
    saleId: {
      type: Number,
      required: true,
    },
    value: {},
    // カード決済が利用可能か
    cardAvailable: {
      type: Boolean,
      default: true,
    },
    // コンビニ決済が利用可能か
    conveniAvailable: {
      type: Boolean,
      default: true,
    },
    // Pay.JPのクライアントシークレット
    payjpClientSecret: {
      type: String,
      required: true,
    },
    errors: {
      default: () => {
        return {}
      },
    },
  },

  data() {
    return {
      payment: {
        // 選択された支払い方法
        id: null,
        cardFormIsOK: false,
        // コンビニ決済で選択されたコンビニのコード
        conveniCvs: null,
      },
      cardAndPaypay: {
        clientSecret: null,
        paymentFlowId: null,
      },
      convenis,
    }
  },

  computed: {
    // カード決済とPayPay決済の両方の情報が揃っていて利用可能な状態か
    cardAndPaypayIsReady() {
      return this.cardAndPaypay.clientSecret && this.cardAndPaypay.paymentFlowId
    },
  },

  created() {
    if (!this.value) return
    this.payment.id = this.value.id
    this.payment.cardFormIsOK = this.value.cardFormIsOK
    this.payment.conveniCvs = this.value.conveniCvs
  },

  methods: {
    // カード決済フォームの状態(OK or NG)が変化したら呼ばれる
    updateCardFormStatus(isOk) {
      this.payment.cardFormIsOK = isOk
      this.update()
    },
    update() {
      this.$emit('input', _.cloneDeep(this.payment))
    },
    getError(key) {
      let error
      if (key === 'exp') {
        error = _.get(this.errors, 'card.exp_month') || _.get(this.errors, 'card.exp_year')
      } else {
        error = _.get(this.errors, key)
      }
      return error ? error.message : null
    },
    // 親コンポーネントからの呼び出し用
    async confirmPayment(returnUrl, customerEmail, customerTel) {
      console.log('confirmPayment(iine-payment-form)', returnUrl, customerEmail, customerTel)
      if (this.$refs.payjpCardAndPaypayFormComponent) {
        await this.$refs.payjpCardAndPaypayFormComponent.confirmPayment(
          returnUrl,
          customerEmail,
          customerTel
        )
      }
    },
  },
}
</script>

<style lang="sass">
.iine-payment-form
  .description
    padding: 0.5rem

  .conveni-group
    > *
      margin-bottom: 0.1rem
      .conveni-icon
        display: inline-block
        width: 1.8rem
        height: 1.8rem
        margin-right: 0.5rem
        background-size: cover
        &.seven
          background-image: url(../../assets/seven.gif)
        &.famima
          background-image: url(../../assets/famima.gif)
        &.lawson
          background-image: url(../../assets/lawson.gif)
        &.mini
          background-image: url(../../assets/mini.gif)
        &.circle
          background-image: url(../../assets/circle.gif)
        &.sunkus
          background-image: url(../../assets/sunkus.gif)
</style>
